import React from 'react';

import { bool, func } from 'prop-types';

import Menu from '@mui/material/Menu';
import Logout from '@mui/icons-material/Logout';
import {
  Avatar,
  Divider,
  ListItemIcon, MenuItem,
} from '@mui/material';
import { useAuth } from '../../middlewares/hooks/auth.hook';

function AvatarMenu({ anchorEl, handleClose }) {
  const open = Boolean(anchorEl);
  const { logout } = useAuth();

  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <MenuItem onClick={handleClose}>
        <Avatar />
        Profile
      </MenuItem>
      <MenuItem onClick={handleClose}>
        <Avatar />
        My account
      </MenuItem>
      <Divider />
      <MenuItem onClick={() => {
        logout();
        handleClose();
      }}
      >
        <ListItemIcon>
          <Logout fontSize="small" />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  );
}

AvatarMenu.propTypes = {
  anchorEl: bool,
  handleClose: func.isRequired,
};

AvatarMenu.defaultProps = {
  anchorEl: false,
};

export default AvatarMenu;
